export default "__VITE_ASSET__BzKIe$jd__"